import Box from '@mui/material/Box';
import type { ReactElement } from 'react';

import { CategoryRow } from './CategoryRow';
import { SubCategoryDropdown, type SubCategoryDropdownProps } from './SubCategoryDropdown';

export type CategoryDropdownItemProps = SubCategoryDropdownProps & { uuid: string };

export type CategoryDropdownProps = {
    label: string;
    count: number;
    items?: ReadonlyArray<CategoryDropdownItemProps>;
    open?: boolean;
    checked?: boolean;
    indeterminate?: boolean;
    dense?: boolean;
    onToggleOpen?: () => void;
    onToggleChecked?: () => void;
    disabled?: boolean;
};

export function CategoryDropdown({
    label,
    count,
    items = [],
    open = false,
    checked = false,
    indeterminate = false,
    dense = false,
    onToggleOpen,
    onToggleChecked,
    disabled,
}: CategoryDropdownProps): ReactElement {
    const expandHandler = items.length > 0 ? onToggleOpen : undefined;

    return (
        <Box
            sx={{
                border: 1,
                borderColor: 'divider',
                borderRadius: '4px',
            }}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.25,
                    px: 1,
                    py: dense ? 0.5 : 1.5,
                }}>
                <CategoryRow
                    label={`${label} (${count})`}
                    checked={checked}
                    indeterminate={indeterminate}
                    open={open}
                    onChange={onToggleChecked}
                    onToggleOpen={expandHandler}
                    disabled={disabled}
                />
            </Box>

            {open &&
                items.map(({ uuid, ...subProps }) => (
                    <SubCategoryDropdown key={uuid} {...subProps} dense={dense} disabled={disabled} />
                ))}
        </Box>
    );
}
